import {
    useState,
    useEffect,
    useRef
} from "react";
import {
    Navigate,
    useParams,
    useNavigate
} from "react-router-dom";
import {
    Box,
    Typography,
    Container,
    Grid,
    Paper,
    Skeleton,
    IconButton,
    TextField,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    TableSortLabel,
    Button,
    Tooltip,
    List,
    ListItemButton,
    ListItemText,
    ListItem,
    Chip,
    ListItemIcon
} from '@mui/material';
import SectionTitle from "../../components/common/SectionTitle";
import ClientPosMappingSum from "../../components/client/pos/ClientPosMappingSum";
import ClientPosMappingUpload from "../../components/client/pos/ClientPosMappingUpload";
import CurrentClientContext from "../../providers/CurrentClientProvider";
import ClientService from "../../services/ClientService";
import EditIcon from '@mui/icons-material/Edit';
import constant from "../../constants/constant";
import MessageContext from "../../providers/GlobalTip";

const jss = {
    noteMessage: {
        '.MuiListItemText-primary': {
            wordBreak: 'break-all',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            overflow: 'hidden',
            fontSize: 12,
            whiteSpace: 'pre-wrap'
        }
    },
    posStyles: {
        '.MuiListItemText-primary': {
            wordBreak: 'break-all',
            fontSize: 12,
            whiteSpace: 'pre-wrap',
            pr: 1
        },
        '.MuiListItemText-secondary': {
            wordBreak: 'break-all',
            fontSize: 12,
            whiteSpace: 'pre-wrap'
        }
    },
    listStyle: {
        backgroundColor: 'white',
        maxHeight: '60vh',
        minHeight: '50px',
        overflowY: 'scroll'
    }
}

function ClientPosMapping(props) {
    const currentClientContext = CurrentClientContext.useClient()
    const [locations, setLocations] = useState([])
    const [classes, setClasses] = useState([])
    const [posList, setPosList] = useState([])
    const [clientPosList, setClientPosList] = useState([])
    const [locationList, setLocationList] = useState([])
    const [editPos, setEditPos] = useState(false)
    const [checkedPos, setCheckedPos] = useState([])
    const [pickedClassId, setPickedClassId] = useState(0)
    const [statistics, setStatistics] = useState({})
    const [posCodes, setPosCodes] = useState({})
    const messageContext = MessageContext.useMessage();

    useEffect(() => {
        if( currentClientContext.client ) {
            getPosClientData()
            getClientPosList()
            getClientLocations()
        }
    }, [currentClientContext.client])

    function updatedFile() {
        getPosClientData()
        getClientPosList()
        getClientLocations()
    }

    async function getClientLocations() {
        const client = currentClientContext.client.Id
        let response = await ClientService.getClientLocations(client)
        let tmpPos = {}
        response.map(loc => {
            tmpPos[loc.client_location_id] = loc.ClientMapping
        })
        setPosCodes(tmpPos)
        setLocations(response)
    }
    async function getPosClientData() {
        const client = currentClientContext.client.Id
        let response = await ClientService.getPosClassMapData(client)
        setClasses(Object.values(response['mapping']))
        setStatistics(response.statistics)
    }

    async function getClientPosList() {
        const client = currentClientContext.client.Id
        let response = await ClientService.getClientPosList(client)
        setClientPosList(Object.values(response))

    }

    function togglePosMapping(pos, pickedClassId) {
        const client = currentClientContext.client.Id
        ClientService.togglePosClassesMapping(client, pickedClassId, pos)
    }

    function clickToClass(item) {
        setPickedClassId(item.id)
        setPosList(Object.values(item.pos_list))
        setCheckedPos([])
        let posList = []
        Object.values(item.pos_list).map(p => {
            posList.push(p.Id)
        })
        setCheckedPos([
            ...posList
        ])
        setLocationList([])
        setLocationList(item.locations)
        setEditPos(false)
    }

    function editPosAction() {
        if (!pickedClassId) return;
        setEditPos(!editPos)
    }

    function updatePosMapper(pos) {
        let exists = -1
        checkedPos.map((p, i) => {
            if (p === pos) {
                exists = i
            }
        })

        if (exists > -1) {
            checkedPos.splice(exists, 1)
            setCheckedPos([
                ...checkedPos
            ])
        } else {
            checkedPos.push(pos)
            setCheckedPos([
                ...checkedPos
            ])
        }
        togglePosMapping(pos, pickedClassId)
    }

    const common_input_props = {
        fullWidth: true,
        variant: "outlined",
        size: "small",
        sx: {mt:2},
    }

    async function updatePOS(newPos, loc) {
        if (newPos == loc.ClientMapping) return;

        const response = await ClientService.updateLocationPos(loc.clientid, loc.client_location_id, newPos)
        setPosCodes({
            ...posCodes,
            [loc.client_location_id]: newPos
        })

        let _l = locations
        _l.map(loc => {
            if (loc.client_location_id == response.client_location_id) {
                loc.ClientMapping = response.ClientMapping
            }
        })

        setLocations(_l)
        messageContext.showSuccess('POS Updated')
    }

    function setPos(e, loc) {
        setPosCodes({
            ...posCodes,
            [loc.client_location_id]: e.target.value
        })
    }

    return <Box>
        <Grid container spacing={2}>
            <Grid item lg={3} xs={12} sx={{mt: 2}}>
                <ClientPosMappingUpload success={updatedFile} />
            </Grid>
            <Grid item lg={9} xs={12} sx={{mt: 2}}>
                <ClientPosMappingSum statistics={statistics} />
            </Grid>
        </Grid>
        <Grid container spacing={2} sx={{mt: 0}}>
            <Grid item lg={3} md={12} xs={12}>
                <Paper elevation={2}>
                    <SectionTitle
                        label="Location POS Code"
                    />
                    <TableContainer sx={{maxHeight: 290}}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Location</TableCell>
                                    <TableCell align='right'>Code</TableCell>
                                    <TableCell align='right'>POS Code</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {locations.map(loc => {
                                    if (!loc.location_name) return false;
                                    return <TableRow key={'loc_list_' + loc.client_location_id}>
                                        <TableCell sx={{whiteSpace: 'nowrap'}}>{loc.location_name}</TableCell>
                                        <TableCell align='right'>{loc.location_code}</TableCell>
                                        <TableCell align='right'>
                                            <TextField
                                                {...common_input_props}
                                                label="POS Code"
                                                name="pos_code"
                                                value={posCodes[loc.client_location_id] || ''}
                                                onChange={e => {setPos(e, loc)}}
                                                onBlur={e => {updatePOS(e.target.value, loc)}}
                                            />
                                        </TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item md={3} xs={12}>
                <Paper elevation={2}>
                    <SectionTitle
                        label={`Orbit Classes (${classes.length})`}
                    />
                    <List sx={jss.listStyle} dense>
                        {classes?.map(_class => {
                            return  <ListItem
                                key={_class.code}
                                selected={_class.id === pickedClassId}
                                sx={{
                                    fontSize: 12,
                                    marginBottom: '5px',
                                    height: '40px'
                                }}
                                secondaryAction={<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <Typography sx={{marginRight: '10px', fontSize: 12}}>{_class.code}</Typography>
                                    <Tooltip title={_.invert(constant.SERVICE_TYPE_ID)[_class.service_type_id]}>
                                        <Chip sx={{backgroundColor: 'rgba(0, 0, 0, 0.01)'}} label={_.invert(constant.SERVICE_TYPE_ID)[_class.service_type_id].substring(0,1)} />
                                    </Tooltip>
                                    </Box>
                                }
                            >
                                <ListItemButton key={`orbit_class_${_class.code}`} onClick={e => clickToClass(_class)}>
                                    <ListItemText sx={jss.noteMessage} primary={_class.name}/>
                                </ListItemButton>
                            </ListItem>
                        })}
                    </List>
                </Paper>
            </Grid>
            <Grid item md={3} xs={12}>
                <Paper elevation={2}>
                    <SectionTitle
                        label={`POS Classes Mapped (${!editPos ? checkedPos.length : clientPosList.length})`}
                        rightComponent={
                            <Tooltip title="Edit POS">
                                <IconButton component="a" onClick={editPosAction} target="_blank" sx={{color: '#666'}}>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    />
                    <List sx={jss.listStyle} dense>
                        {!editPos ? posList?.map(pos => {
                            return <ListItem
                                key={'pos_' + pos.Code}
                                sx={{
                                    fontSize: 11
                                }}
                                disablePadding
                            ><ListItemButton key={`pos_class_${pos.Id}`}>
                                <ListItemText sx={jss.posStyles} primary={pos.Name.toUpperCase()} />
                                <ListItemText sx={jss.posStyles} secondary={pos.Code.toUpperCase()} />
                            </ListItemButton>
                            </ListItem>
                        }) :
                            clientPosList.map(cPos => {
                                return <ListItemButton key={'c_pos_' + cPos.Id} role={undefined} onClick={() => updatePosMapper(cPos.Id)} dense>
                                            <ListItemIcon>
                                                <Checkbox
                                                    key={'c_pos_check_' + cPos.Id}
                                                    edge="start"
                                                    checked={checkedPos.indexOf(cPos.Id) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby': cPos.Id }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText id={cPos.Id} primary={cPos.Name.toUpperCase() + ' (' + cPos.Code + ')'} />
                                        </ListItemButton>
                            })
                        }
                    </List>
                </Paper>
            </Grid>
            {locationList.length > 1 && <Grid item md={3} xs={12}>
                <Paper elevation={2}>
                    <SectionTitle
                        label={`Locations (${locationList.length})`}
                    />
                    <List sx={{
                        backgroundColor: 'white',
                    }} dense>
                        {locationList?.map(loc => {
                            return <ListItem
                                key={loc.location_code}
                                sx={{
                                    fontSize: 11
                                }}
                                secondaryAction={
                                    loc.location_code
                                }
                                disablePadding
                            >
                                <ListItemButton key={`location_${loc.client_location_id}`} >
                                    <ListItemText sx={jss.noteMessage} primary={loc.location_name}/>
                                </ListItemButton>
                            </ListItem>
                        })}
                    </List>
                </Paper>
            </Grid>}
        </Grid>
    </Box>
}

export default ClientPosMapping